import {getAuthRoutesDefinitions} from "@src/features/auth/auth-routes";
import {RequireIsLoggedInLayout} from "@src/features/auth/layouts/require-is-logged-in-layout";
import {RequireIsNotLoggedInLayout} from "@src/features/auth/layouts/require-is-not-logged-in-layout";
import {RequireIsSpaceMemberLayout} from "@src/features/auth/layouts/require-is-space-member-layout";
import { DebugScreen } from "@src/features/debug/ui/DebugScreen";
import { getLiveShuttlesRoutesDefinitions } from "@src/features/live-shuttles/live-shuttles-routes";
import { getRideShareRoutesDefinitions } from "@src/features/ride-share/ride-share-routes";
import {SpaceHomeScreen} from "@src/features/space-home/components/space-home-screen";
import {getTimedShuttlesRoutesDefinitions} from "@src/features/timed-shuttles/timed-shuttles-routes";
import { UsersScreen } from "@src/features/users/ui/screens/users-screen";
import {getUsersRoutesDefinitions} from "@src/features/users/users-routes";
import { getWelfareRoutesDefinitions } from "@src/features/welfare/welfare-routes";
import {AuthLoaderLayout} from "@src/ui/layouts/auth-loader-layout";
import {TopbarLayout} from "@src/ui/layouts/topbar-layout";
import {DashboardsPickerScreen} from "@src/ui/screens/dashboard-picker-screen";
import {HomeScreen} from "@src/ui/screens/home-screen";
import * as React from "react";
import {createBrowserRouter, type RouteObject, RouterProvider} from "react-router-dom";
import { getRouteTimedShuttleRoutesDefinitions } from "@src/features/route-timed-shuttle/route-timed-shuttle-routes";
import { RidesList } from "@src/features/quick-actions/ui/rides-list";
import {AddRideScreen} from "@src/features/quick-actions/ui/add-ride-screen";
import {InviteSuccessScreen} from "@src/features/auth/components/invite-success-screen";


const InviteLoginScreen = React.lazy(async () => import("@src/features/auth/components/invite-login-screen")
	.then(({InviteLoginScreen: Screen}) => ({default: Screen})));


const APP_ROUTES_DEFINITIONS = getAppRoutesDefinitions();


const ROUTER = createBrowserRouter(APP_ROUTES_DEFINITIONS);


export function AppRoutes() {
	return (
		<RouterProvider router={ROUTER}/>
	);
}


function getAppRoutesDefinitions(): RouteObject[] {
	// todo consider removing return type hint returning as const for better type hints? same for all
	return [
		{
			path: "/",
			// todo why AuthLoaderLayout and other layouts here, and other providers in <App/>
			element: <AuthLoaderLayout/>,
			children: [
				{
					element: <TopbarLayout/>,
					children: [
						{
							index: true,
							element: <HomeScreen/>,
						},
						{
							path: "auth",
							element: <RequireIsNotLoggedInLayout/>,
							children: getAuthRoutesDefinitions(),
						},
						{
							path: "dashboard",
							element: <RequireIsLoggedInLayout/>,
							children: [
								{
									index: true,
									element: <DashboardsPickerScreen/>,
								},
								{
									path: ":spaceId",
									element: <RequireIsSpaceMemberLayout/>,
									children: getSpaceRoutesDefinitions(),
								}
							],
						},
					],
				},
			],
		},
		{
			path: "/login/:groupId",
			element: <React.Suspense fallback={null}><InviteLoginScreen/></React.Suspense>,
		},
		{
			path: "/login/:groupId/success",
			element: <InviteSuccessScreen/>,
		},
		{
			path: "/quick-actions/:spaceId/rides",
			element: <RidesList />,
		},
		{
			path: "/quick-actions/:spaceId/rides/add",
			element: <AddRideScreen />,
		},
	] satisfies RouteObject[];
}


function getSpaceRoutesDefinitions(): RouteObject[] {
	return [
		{
			index: true,
			element: <SpaceHomeScreen/>,
		},
		// {
		// 	path: "users",
		// 	children: getUsersRoutesDefinitions(),
		// },
		{
			path: "timed-shuttles",
			children: getTimedShuttlesRoutesDefinitions(),
		},
		{
			path: "live-shuttles",
			children: getLiveShuttlesRoutesDefinitions(),
		},
		{
			path: "ride-share",
			children: getRideShareRoutesDefinitions(),
		},
		{
			path: "welfare",
			children: getWelfareRoutesDefinitions(),
		},
		{
			path: "debug",
			element: <DebugScreen />,
		},
		{ path: "users", element: <UsersScreen /> },
		{
			path: "route-timed-shuttle",
			children: getRouteTimedShuttleRoutesDefinitions(),
		},
	] satisfies RouteObject[];
}
